import { render } from "./GrantsForm.vue?vue&type=template&id=23e39749&scoped=true"
import script from "./GrantsForm.vue?vue&type=script&lang=js"
export * from "./GrantsForm.vue?vue&type=script&lang=js"

import "./GrantsForm.vue?vue&type=style&index=0&id=23e39749&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e39749"]])

export default __exports__